module.exports = __webpack_public_path__ + "media/images/users/user-3-60ae01e195778b11cd13b6db7f80385c.jpg";